import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    offsetTop: 0,
    language: 'th',
    userInfo: {
      methods: [{ username: '' }]
    },
    // announce
    announce: {
      description_th:
        'ขอเชิญประชุมสามัญผู้ถือหุ้น ประจำปี 2567<br>บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)<br>วันพฤหัสบดีที่ 25 เมษายน 2567 เวลา 14.00 น.<br>ณ ห้องประชุมไอเน็ตฮอลล์ ชั้นไอที อาคารไทยซัมมิท ทาวเวอร์',
      description_eng:
        'Invite to the Annual General<br>Meeting of shareholders year 2024<br>Internet Thailand Public Company Limited<br>April 25, 2024 at at 2.00 p.m.<br>INET Hall, IT Floor, Thai Summit Tower',
      text_link_th: 'รายละเอียดเพิ่มเติม',
      text_link_eng: 'view more link',
      link_th:
        'https://ir.inet.co.th/home/shareholder-information/shareholder-meeting',
      link_eng:
        'https://ir.inet.co.th/home/shareholder-information/shareholder-meeting',
      path_th:
        'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
      path_eng:
        'https://ir.inet.co.th/api/v1/file/acdf8e5e-aecc-41d5-b85a-6baffd29fab1.pdf',
      title_download_th: 'ดาวน์โหลด',
      title_download_eng: 'Download'
    },
    // footer
    footer: {
      title_th: 'ติดต่อเรา',
      title_eng: 'Contact Us',
      address_th:
        '1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12<br>และชั้น IT ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ<br>เขตห้วยขวาง กรุงเทพมหานคร 10310',
      address_eng:
        '1768 Thai Summit Tower, 10th -12th Floor<br>and IT Floor New Petchburi Road,<br>Bang Kapi, Huay Khwang, Bangkok 10310',
      address_mobile_th:
        '1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310',
      address_mobile_eng:
        '1768 Thai Summit Tower, 10th -12th Floor and IT Floor New Petchburi Road, Bang Kapi, Huay Khwang, Bangkok 10310',
      phone: '0-2257-7001',
      email: 'ir@inet.co.th',
      facebook: 'facebookmock'
    },
    // homeInvestorRelations
    IR_news: {
      title_th: 'ข่าวสารล่าสุด',
      title_eng: 'News',
      image_title: 'assets/images/news/news_icon.png',
      btn_view_all_th: 'ดูทั้งหมด',
      btn_view_all_eng: 'View All'
    },
    news: [],
    // ESG news
    news_esg: {
      img_esg: 'assets/images/ESGstampNews/ESG.png',
      title_th: 'Goal',
      title_eng: 'Goal',
      text_page_th: 'หน้า',
      text_page_eng: 'Page',
      esg: [
        {
          tag: 'noPoverty',
          number: 1,
          title_th: 'No Poverty',
          title_eng: 'No Poverty',
          image: 'assets/images/ESGstampNews/noPoverty.png'
        },
        {
          tag: 'zeroHunger',
          number: 2,
          title_th: 'Zero Hunger',
          title_eng: 'Zero Hunger',
          image: 'assets/images/ESGstampNews/zeroHunger.png'
        },
        {
          tag: 'goodHealthAndWellBeing',
          number: 3,
          title_th: 'Good Health And Well-Being',
          title_eng: 'Good Health And Well-Being',
          image: 'assets/images/ESGstampNews/goodHealthAndWellBeing.png'
        },
        {
          tag: 'qualityEducation',
          number: 4,
          title_th: 'Quality Education',
          title_eng: 'Quality Education',
          image: 'assets/images/ESGstampNews/qualityEducation.png'
        },
        {
          tag: 'genderEquality',
          number: 5,
          title_th: 'Gender Equality',
          title_eng: 'Gender Equality',
          image: 'assets/images/ESGstampNews/genderEquality.png'
        },
        {
          tag: 'cleanWaterAndSanitation',
          number: 6,
          title_th: 'Clean Water And Sanitation',
          title_eng: 'Clean Water And Sanitation',
          image: 'assets/images/ESGstampNews/cleanWaterAndSanitation.png'
        },
        {
          tag: 'affordableAndCleanEnergy',
          number: 7,
          title_th: 'Affordable And Clean Energy',
          title_eng: 'Affordable And Clean Energy',
          image: 'assets/images/ESGstampNews/affordableAndCleanEnergy.png'
        },
        {
          tag: 'decentWorkAndEconomicGrowth',
          number: 8,
          title_th: 'Decent Work And Economic Growth',
          title_eng: 'Decent Work And Economic Growth',
          image: 'assets/images/ESGstampNews/decentWorkAndEconomicGrowth.png'
        },
        {
          tag: 'industryInnovationAndInfrastructure',
          number: 9,
          title_th: 'Industry,Innovation And Infrastructure',
          title_eng: 'Industry,Innovation And Infrastructure',
          image:
            'assets/images/ESGstampNews/industryInnovationAndInfrastructure.png'
        },
        {
          tag: 'reducedInequalities',
          number: 10,
          title_th: 'Reduced Inequalities',
          title_eng: 'Reduced Inequalities',
          image: 'assets/images/ESGstampNews/reducedInequalities.png'
        },
        {
          tag: 'sustainableCitiesAndCommunities',
          number: 11,
          title_th: 'Sustainable Cities And Communities',
          title_eng: 'Sustainable Cities And Communities',
          image:
            'assets/images/ESGstampNews/sustainableCitiesAndCommunities.png'
        },
        {
          tag: 'responsibleConsumptionAndProduction',
          number: 12,
          title_th: 'Responsible Consumption And Production',
          title_eng: 'Responsible Consumption And Production',
          image:
            'assets/images/ESGstampNews/responsibleConsumptionAndProduction.png'
        },
        {
          tag: 'climateAction',
          number: 13,
          title_th: 'Climate Action',
          title_eng: 'Climate Action',
          image: 'assets/images/ESGstampNews/climateAction.png'
        },
        {
          tag: 'lifeBelowWater',
          number: 14,
          title_th: 'Life Below Water',
          title_eng: 'Life Below Water',
          image: 'assets/images/ESGstampNews/lifeBelowWater.png'
        },
        {
          tag: 'lifeOnland',
          number: 15,
          title_th: 'Life On Land',
          title_eng: 'Life On Land',
          image: 'assets/images/ESGstampNews/lifeOnland.png'
        },
        {
          tag: 'peaceJusticeAndStrongInstitutions',
          number: 16,
          title_th: 'Peace,Justice And Strong Institutions',
          title_eng: 'Peace,Justice And Strong Institutions',
          image:
            'assets/images/ESGstampNews/peaceJusticeAndStrongInstitutions.png'
        },
        {
          tag: 'partnershipsForTheGoals',
          number: 17,
          title_th: 'Partnerships For The Goals',
          title_eng: 'Partnerships For The Goals',
          image:
            'assets/images/ESGstampNews/peaceJusticeAndStrongInstitutions.png'
        }
      ]
    },

    // stock in home
    stock: {
      title_val_th: 'ปริมาณ (หุ้น)',
      title_val_eng: 'Volumn (Shares)',
      title_date_th: 'ข้อมูลล่าสุด',
      title_date_eng: 'Latest',
      link_set_th:
        'https://www.set.or.th/th/market/product/stock/quote/INET/price',
      link_set_eng:
        'https://www.set.or.th/en/market/product/stock/quote/INET/price'
    },
    // companyOverview > corporateInformation
    inet_vision: {
      description1_th:
        '<p>เป็นบริษัทที่เป็นผู้นำด้านการส่งเสริม<br>และบ่มเพาะนวัตกรรมภายในประเทศ<br>ให้เกิดความสามารถในการแข่งขันและยั่งยืน</p>',
      description1_eng:
        '<p>Be a leading company in promoting<br>and incubating innovations in the country<br>for competitiveness and sustainability.',
      description1_mobile_th:
        'เป็นบริษัทที่เป็นผู้นำด้านการส่งเสริม และบ่มเพาะนวัตกรรมภายในประเทศให้เกิดความสามารถในการแข่งขันและยั่งยืน',
      description1_mobile_eng:
        'Be a leading company in promoting and incubating innovations in the country for competitiveness and sustainability.'
    },
    inet_mission: {
      image_title: 'assets/images/corporateInformation/inet_mission_title.png',
      image_bg: 'assets/images/corporateInformation/inet_mission_bg.png',
      image_line: 'assets/images/corporateInformation/inet_mission_line.png',
      description1_th:
        '<p>มุ่งเน้นการสร้าง High Technology Real Estate / <br>Infrastructure ที่จำเป็นต่อการขับเคลื่อนประเทศ<br>เข้าสู่ยุค 4.0 เพื่อลดการพึ่งพาต่างประเทศ</p>',
      description1_eng:
        'Focus on the creation of High Technology Real Estate /Infrastructure that is necessary to drive the country toward into the 4.0 era in order to reduce the dependence on foreign countries.',
      description1_mobile_th:
        'มุ่งเน้นการสร้าง High Technology Real Estate / Infrastructure ที่จำเป็นต่อการขับเคลื่อนประเทศเข้าสู่ยุค 4.0 เพื่อลดการพึ่งพาต่างประเทศ',
      description1_mobile_eng:
        'Focus on the creation of High Technology Real Estate /Infrastructure that is necessary to drive the country toward into the 4.0 era in order to reduce the dependence on foreign countries.',
      description2_th:
        '<p>ลงทุนและสนับสนุนนวัตกรรมผ่านผู้พัฒนา<br>และส่งเสริมให้ผู้พัฒนาเป็นเจ้าของธุรกิจ<br>เพื่อให้เกิดความยั่งยืนและเชื่อมโยงงานวิจัย<br>และพัฒนาเข้าสู่ภาคธุรกิจ</p>',
      description2_eng:
        'Investing in and promoting innovation through developers, while empowering them to become business proprietors, fosters long-term sustainability and integrates research and development into the business sector.',
      description2_mobile_th:
        'ลงทุนและสนับสนุนนวัตกรรมผ่านผู้พัฒนาและส่งเสริมให้ผู้พัฒนาเป็นเจ้าของธุรกิจ เพื่อให้เกิดความยั่งยืนและเชื่อมโยงงานวิจัยและพัฒนาเข้าสู่ภาคธุรกิจ',
      description2_mobile_eng:
        'Investing in and promoting innovation through developers, while empowering them to become business proprietors, fosters long-term sustainability and integrates research and development into the business sector.'
    },
    inet_core_value: {
      image_title:
        'assets/images/corporateInformation/inet_core_value_title.png',
      image_bg: 'assets/images/corporateInformation/inet_core_value_bg.png',
      image_energetic: 'assets/images/corporateInformation/energetic.png',
      energetic_description_th: [
        'เป็นบริษัทที่กระฉับกระเฉง ทำงานรวดเร็ว มีพลัง',
        'พนักงานต้องมีความกระตือรือร้น ทำงานอย่างคึกคัก ไม่มีเฉื่อย เช้าชามเย็นชาม'
      ],
      energetic_description_eng: [
        'Be an energetic, fast-paced, energetic company',
        'Employees must be enthusiastic, energetic,productive and no sluggishness.'
      ],
      image_innovation: 'assets/images/corporateInformation/innovation.png',
      innovation_description_th: [
        'เป็นบริษัทที่มีนวัตกรรมตลอดเวลา',
        'พนักงานต้องเป็นคนช่างสังเกต พัฒนาอย่างไม่หยุดยั้ง'
      ],
      innovation_description_eng: [
        'Be an innovative company of all the time.',
        'Employees must be observant and infinitely evolving.'
      ],
      image_neutral: 'assets/images/corporateInformation/neutral.png',
      neutral_description_th: [
        'เป็นบริษัทที่มีความเป็นกลาง ไม่ฝักใฝ่ฝ่ายใด',
        'พนักงานต้องมีแต่บริษัท ไม่แบ่งพรรคแบ่งพวก มีแต่พวกเดียว'
      ],
      neutral_description_eng: [
        'Be a neutral, unbiased, and reliable company.',
        'Employees must be committed to the company, no discrimination and being as one team.'
      ],
      image_trustworthy: 'assets/images/corporateInformation/Trustworthy.png',
      trustworthy_description_th: [
        'เป็นบริษัทที่ไว้ใจได้ ทุกคนสบายใจที่ทำธุรกิจด้วย',
        'พนักงานต้องมีความซื่อสัตย์ เป็นที่น่าไว้วางใจทั้งต่องาน, ลูกค้า, เพื่อนร่วมงาน และผู้บังคับบัญชา'
      ],
      trustworthy_description_eng: [
        'Be a trustworthy company that everyone is comfortabledoing business with.',
        'Employees must be honest and trustworthy for work, customers, colleagues and supervisors.'
      ],
      image_service: 'assets/images/corporateInformation/service.png',
      image_serviceAll_th: 'assets/images/corporateInformation/serviceAll.png',
      image_serviceAll_eng: 'assets/images/corporateInformation/serviceAll.png',
      link_serviceAll_th: 'https://inet.co.th/services.php',
      link_serviceAll_eng: 'https://inet.co.th/services.php?lang=en',
      image_structure_1_th:
        'assets/images/corporateInformation/structure_1_th.jpg',
      image_structure_1_eng:
        'assets/images/corporateInformation/structure_1_eng.jpg',
      image_structure_2_th:
        'assets/images/corporateInformation/structure_2_th.jpg',
      image_structure_2_eng:
        'assets/images/corporateInformation/structure_2_eng.jpg',

      btn_close_th: 'ปิด',
      btn_close_eng: 'close'
    },
    // financialInformationMain > annualReport56-1\
    annual_report_now: {
      title_th: 'รายงานประจำปี',
      title_eng: 'Annual Report',
      sub_title_th: 'แบบ 56-1 One Report',
      sub_title_eng: 'Form 56-1 One Report',
      image_divider: 'assets/images/annualReport_56_1/Divider.png',
      // image_download: 'assets/images/annualRepor_56_1/download.svg',
      title_download_th: 'ดาวน์โหลด',
      title_download_eng: 'Download'
    },
    annual_report_section: {
      title_annualReport_th: 'รายงานประจำปีย้อนหลัง',
      title_annualReport_eng: 'Annual Report',
      img_dot: 'assets/images/56-1/dot.png',
      btn_view_all_th: 'ดูทั้งหมด',
      btn_view_all_eng: 'View All',
      title_download_th: 'ดาวน์โหลด',
      title_download_eng: 'Download'
    },
    report561_section: {
      title_th: 'แบบ 56-1',
      title_eng: 'Form 56-1',
      sub_title_th: 'แสดงเอกสารเพิ่มเติม',
      sub_title_eng: 'View More',
      detail_th:
        'เอกสารส่วนนี้เป็นเอกสาร<br>แบบแสดงรายการข้อมูลประจำปี <br> หรือแบบ 56-1 ย้อนหลังก่อนปี 2562',
      detail_eng:
        'This document was Form 56-1 <br>that included information from the period prior to 2019.',
      title_download_th: 'ดาวน์โหลด',
      title_download_eng: 'Download'
    },
    annual_report: [],
    report561: [],
    // financialInformationMain > annualReport
    annual_report_page: {
      title_th: 'รายงานประจำปี',
      title_eng: 'Annual Report',
      img_dot: 'assets/images/56-1/dot.png',
      title_download_th: 'ดาวน์โหลด',
      title_download_eng: 'Download',
      btn_back_th: 'กลับไปยังหน้า รายงานประจำปีและ 56-1 One Report',
      btn_back_eng: 'Return to page Annual Report 56-1 One Report'
    },
    // financialInformationMain > 56-1\
    report561_page: {
      title_th: 'แบบ 56-1',
      title_eng: 'Form 56-1',
      img_dot: 'assets/images/56-1/dot.png',
      title_download_th: 'ดาวน์โหลด',
      title_download_eng: 'Download',
      btn_back_th: 'กลับไปยังหน้าแบบ 56-1',
      btn_back_eng: 'Return to page Form 56-1'
    },
    // shareholderInformation > stockInformation
    stock_information_page: {
      title_th: 'ข้อมูลหลักทรัพย์',
      title_eng: 'Stock Information',
      img_dot: 'assets/images/56-1/dot.png',
      img_factsheet: 'assets/images/stockInformation/Factsheet.png',
      link_img_factsheet_th:
        'https://www.set.or.th/th/market/product/stock/quote/inet/factsheet',
      link_img_factsheet_eng:
        'https://www.set.or.th/en/market/product/stock/quote/inet/factsheet',
      market: {
        title_th: 'ตลาด',
        title_eng: 'Market',
        val_th: 'SET',
        val_eng: 'SET'
      },
      industry: {
        title_th: 'กลุ่มอุตสาหกรรม',
        title_eng: 'Industry',
        val_th: 'เทคโนโลยี',
        val_eng: 'Technology'
      },
      business: {
        title_th: 'หมวดธุรกิจ',
        title_eng: 'Sector',
        val_th: 'เทคโนโลยีสารสนเทศและการสื่อสาร',
        val_eng: 'Information & Communication Technology'
      },
      trade_date: {
        title_th: 'วันที่เข้าซื้อขายครั้งแรก',
        title_eng: 'First Trade Date',
        val_th: '14 พ.ย. 2544',
        val_eng: '14 Nov 2001'
      },
      about_stock: {
        header_th: 'รายละเอียดเกี่ยวกับหุ้น',
        header_eng: 'Capital Detail',
        title_th: 'ราคาพาร์',
        title_eng: 'Par Value',
        val_th: '1.00 บาท',
        val_eng: '1.00 Baht'
      },
      about_common_stock: {
        header_th: 'หุ้นสามัญ',
        header_eng: 'Common Stock',
        registered_capital: {
          title_th: 'ทุนจดทะเบียน',
          title_eng: 'Authorized Capital',
          val_th: '596,740,267.00 บาท',
          val_eng: '596,740,267.00 Baht'
        },
        registered_capital_paid: {
          title_th: 'ทุนจดทะเบียนที่ชำระแล้ว',
          title_eng: 'Paid-up Capital',
          val_th: '596,740,267.00 บาท',
          val_eng: '596,740,267.00 Baht'
        }
      },
      about_preferred_stock: {
        header_th: 'หุ้นบุริมสิทธิ',
        header_eng: 'Preferred Stock',
        registered_capital: {
          title_th: 'ทุนจดทะเบียน',
          title_eng: 'Authorized Capital',
          val_th: '-',
          val_eng: '-'
        },
        registered_capital_paid: {
          title_th: 'ทุนจดทะเบียนที่ชำระแล้ว',
          title_eng: 'Paid-up Capital',
          val_th: '-',
          val_eng: '-'
        }
      }
    },
    // contactPage
    contact_page: {
      title_th: 'ติดต่อเรา',
      title_eng: 'Contact Us',
      img_dot: 'assets/images/56-1/dot.png',
      name_company_th: 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)',
      name_company_eng: 'Internet Thailand Public Company Limited',
      title_contact_th: 'ฝ่ายนักลงทุนสัมพันธ์',
      image_line: 'assets/images/contactUs/L_gainfriends_2dbarcodes_BW.png',
      title_contact_eng: ' Investor Relations Department',
      title_line_th: 'INET Debenture Club :',
      title_line_eng: 'INET Debenture Club :',
      address_company_th:
        '1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT<br> ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง <br>กรุงเทพมหานคร 10310',
      address_company_eng:
        '1768 Thai Summit Tower, 10th -12th Floor and<br>IT Floor New Petchaburi Road, Bang Kapi,<br>Huay Khwang, Bangkok 10310',
      address_company_mobile_th:
        '1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310',
      address_company_mobile_eng:
        '1768 Thai Summit Tower, 10th -12th Floor and IT Floor New Petchaburi Road, Bang Kapi, Huay Khwang, Bangkok 10310',
      img_building: 'assets/images/contactUs/building.png',
      phone: {
        title_th: 'โทรศัพท์ :',
        title_eng: 'Phone :',
        val_th: '0-2257-7000',
        val_eng: '0-2257-7000'
      },
      fax: {
        title_th: 'โทรสาร :',
        title_eng: 'Fax :',
        val_th: '0-2257-1379',
        val_eng: '0-2257-1379'
      },
      phone2: {
        title_th: 'โทรศัพท์ :',
        title_eng: 'Phone :',
        val_th: '0-2257-7001',
        val_eng: '0-2257-7001'
      },
      email: {
        title_th: 'Email :',
        title_eng: 'Email :',
        val_th: 'ir@inet.co.th',
        val_eng: 'ir@inet.co.th'
      },
      service_center: {
        title_th: 'ศูนย์บริการลูกค้า :',
        title_eng: 'Call Center :',
        val_th: '0-2257-7299',
        val_eng: '0-2257-7299'
      },
      btn_map_th: 'คลิก เพื่อดูแผนที่',
      btn_map_eng: 'View Map',
      noc_center_th: 'ศูนย์ปฏิบัติการเครือข่าย (NOC)',
      noc_center_eng: 'Network Operations Center (NOC)',
      phone_noc: {
        title_th: 'โทรศัพท์ :',
        title_eng: 'Tel. :',
        val_th: '0-2257-7111',
        val_eng: '0-2257-7111'
      },
      fax_noc: {
        title_th: 'โทรสาร :',
        title_eng: 'Fax :',
        val_th: '0-2257-7275',
        val_eng: '0-2257-7275'
      },
      email_noc: {
        title_th: 'Email :',
        title_eng: 'Email :',
        val_th: 'noc@inet.co.th',
        val_eng: 'noc@inet.co.th'
      },
      img_contact: 'assets/images/contactUs/contact.png'
    },
    // inetW2 ใบสำคัญแสดงสิทธิ
    inet_w2_page: {
      title_th: 'ใบสำคัญแสดงสิทธิ INET-W3',
      title_eng: 'The warrants to Purchase Ordinary Shares in INET–W3',
      img_dot: 'assets/images/inetW2/dot.png',
      exercise_date: [
        {
          title_th: 'วันใช้สิทธิ',
          title_eng: 'Exercise Date',
          description_th: [
            'วันกำหนดใช้สิทธิครั้งแรก วันที่ 23 สิงหาคม พ.ศ. 2567',
            'วันกำหนดใช้สิทธิครั้งสุดท้าย วันที่ 25 พฤศจิกายน พ.ศ. 2567'
          ],
          description_eng: [
            'First Exercise Date on 23 August 2024',
            'Last Exercise Date on 25 November 2024'
          ]
        }
      ],
      exercise_ratio_price: [
        {
          title_th: 'อัตราการใช้สิทธิ',
          title_eng: 'Exercise Ratio',
          description_th: [
            'ใบสำคัญแสดงสิทธิ (INET-W3) 1 หน่วย<br>มีสิทธิซื้อหุ้นสามัญบริษัทได้ 1 หุ้น'
          ],
          description_eng: ['1 unit of INET-W3 <br>to 1 Ordinary Share']
        },
        {
          title_th: 'ราคาใช้สิทธิ',
          title_eng: 'Exercise Price',
          description_th: ['4 บาทต่อ 1 หุ้นสามัญ'],
          description_eng: ['Exercise Price : Baht 4 per share']
        }
      ],
      notification_period: [
        {
          title_th: 'ระยะเวลาการแจ้งความจำนงในการใช้สิทธิ',
          title_eng: 'Notification Period',
          description_th: [
            '<p>ระยะเวลาการแจ้งความจำนงใช้สิทธิครั้งแรก</p><p>วันที่ 16 - 22 สิงหาคม 2567 (เฉพาะวันทำการ)</p><p>เวลา 9.30 - 15.30 น.</p>',
            '<p>ระยะเวลาการแจ้งความจำนงใช้สิทธิครั้งสุดท้าย</p><p>วันที่ 8 - 22 พฤศจิกายน 2567 (เฉพาะวันทำการ)</p><p>เวลา 9.30 - 15.30 น.</p>'
          ],
          description_eng: [
            '<p>For the First Exercise Date Notification of intention to exercise INET-W3 during the period between</p><p>16 - 22 August 2024 (only on business day) </p><p>from 9.30 a.m. to 3.30 p.m.</p>',
            '<p>For the Last Exercise Date Notification of intention to exercise INET-W3 during the period between</p><p>8 - 22 November 2024 (only on business day) </p><p>from 9.30 a.m. to 3.30 p.m.</p>'
          ]
        }
      ],
      place_for_exercise_of_warrants: [
        {
          title_th: 'สถานที่ติดต่อในการแจ้งความจำนงในการใช้สิทธิ',
          title_eng: 'Place for Exercise of Warrants',
          description_th: [
            'บริษัทหลักทรัพย์ โกลเบล็ก จํากัด <br>ฝ่ายปฏิบัติการหลักทรัพย์<br> 87/2 อาคารซีอาร์ซี ออลซีซั่นส์ เพลส ชั้น 12<br> ถนนวิทยุ แขวงลุมพินี เขตปทุมวัน <br>กรุงเทพมหานคร 10330',
            'โทรศัพท์ (66) 0-2672-5999 ต่อ 2521 และ 2525',
            'โทรสาร (66) 0-2672-5929'
          ],
          description_eng: [
            'Globlex Securities Co.,Ltd.<br>Operation Center, 87/2 CRC Building,<br>All Seasons Place 12th floor, Wireless Road,<br> Kweang Lumpini, Khet Phathumwan, Bangkok, 10330',
            'Tel (66)0-2672-5999 Ext. 2521 and 2525',
            'Fax (66)0-2672-592'
          ],
          description_mobile_th: [
            'บริษัทหลักทรัพย์ โกลเบล็ก จํากัด ฝ่ายปฏิบัติการหลักทรัพย์ 87/2 อาคารซีอาร์ซี ออลซีซั่นส์ เพลส ชั้น 12 ถนนวิทยุ แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330',
            'โทรศัพท์ (66) 0-2672-5999 ต่อ 2521 และ 2525',
            'โทรสาร (66) 0-2672-5929'
          ],
          description_mobile_eng: [
            'Globlex Securities Co.,Ltd.Operation Center, 87/2 CRC Building,All Seasons Place 12th floor, Wireless Road,Kweang Lumpini, Khet Phathumwan, Bangkok, 10330',
            'Tel (66)0-2672-5999 Ext. 2521 and 2525',
            'Fax (66)0-2672-592'
          ]
        }
      ],
      // inetW2 ใบสำคัญแสดงสิทธิ >> รายละเอียดการใช้สิทธิใบสำคัญแสดงสิทธิ INET-W2
      title_detail_th: 'รายละเอียดการใช้สิทธิใบสำคัญแสดงสิทธิ INET-W3',
      title_detail_eng: 'Subscription Rights of INET-W3',
      img_title_detail: 'assets/images/inetW2/imgTitleDetail.jpg',
      download_INET_W2: [],
      remark_title_th: 'หมายเหตุ',
      remark_title_eng: 'Remark',
      description_remark_th:
        'กรณีที่ผู้ลงทุนต้องการทราบเลขทะเบียนผู้ถือหลักทรัพย์ เพื่อนำไปกรอกในแบบฟอร์มการแปลงใบสำคัญแสดงสิทธิเป็นหุ้นสามัญ หรือใบจองสิทธิที่จะซื้อหุ้นเพิ่มทุน สามารถสอบถามได้ 3 ช่องทาง คือ (หรือคลิกที่',
      description_remark_eng:
        'Any investor wishing to know the registration number to exercise subscription or conversion rights can contact one of the following channels: (Click',
      link_remark_th: 'https://www.set.or.th/th/tsd/information/faqs',
      link_remark_eng: 'https://www.set.or.th/en/tsd/information/faqs',
      remark_title_section1_th:
        '1. สอบถามทางโทรศัพท์ผ่านระบบอัตโนมัติตลอด 24 ชั่วโมง',
      remark_title_section1_eng: '1. 24-hour automated phone system',
      description_remark_section1_th:
        '<p>-  ติดต่อที่หมายเลข “0 2009 9999” เพื่อเข้าสู่ระบบตอบรับอัตโนมัติ<br>-  เมื่อได้ยินเสียงประกาศ สามารถ “กด 12” ได้ทันที<br>-  ระบบจะประกาศให้กด “เลขที่บัตรประชาชน 13 หลัก และเครื่องหมาย #”<br>-  ระบบจะประกาศหลักทรัพย์ที่ท่านได้รับสิทธิ โดยท่านสามารถกด “หมายเลขเพื่อเลือกหลักทรัพย์” ตามเสียงประกาศ เช่น กด 1 หลักทรัพย์ A, กด 2 หลักทรัพย์ B เป็นต้น<br>-  เพื่อความปลอดภัยสำหรับข้อมูลของท่าน ต้องยืนยันตัวตนโดย “ระบุจำนวนหลักทรัพย์” ได้ 2 วิธี คือ<br>&nbsp;&nbsp;&nbsp;&nbsp;กด 1 หากท่านทราบจำนวนหลักทรัพย์ที่ถืออยู่เดิม หรือ<br>&nbsp;&nbsp;&nbsp;&nbsp;กด 2 หากท่านทราบจำนวนหลักทรัพย์ที่ได้รับสิทธิ์<br>&nbsp;&nbsp;&nbsp;&nbsp;โดยระบบจะให้ท่านกดตัวเลขเพื่อระบุจำนวนหลักทรัพย์<br>-  กรณีระบุจำนวนหลักทรัพย์ถูกต้องระบบจะประกาศเลขทะเบียนผู้ถือหลักทรัพย์</p>',
      description_remark_section1_eng:
        '<p>-  Dial “0 2009 9999”<br>-  After hearing the greetings message, “Press 12”<br>-  Enter your “13 digits national ID card number” followed by the “#” sign<br>-  The system will notify the securities you are entitled to, and prompt you to select the securities of interest by pressing "the corresponding number" , such as 1 for securities A or 2 for securities B<br>-  To maintain data security, you must authenticate your identification by indicating how many stocks you own or are eligible to subscribe to by selecting one of the choices below:<br>&nbsp;&nbsp;&nbsp;&nbsp;Press 1 if you know how many existing stocks you have<br>&nbsp;&nbsp;&nbsp;&nbsp;Press 2 if you know how many stocks you have the right to subscribe to<br>&nbsp;&nbsp;&nbsp;&nbsp;Then, enter the exact number of the chosen option<br>- If the number is correctly specified, the system will disclose the shareholder registration number</p>',
      remark_title_section2_th:
        '2. ตรวจสอบผ่านระบบ TSD Investor Portal (เฉพาะสมาชิกเท่านั้น)',
      remark_title_section2_eng: '2. TSD Investor Portal (for members only)',
      title_link_login_th: 'เข้าสู่ระบบ TSD Investor Portal',
      title_link_login_eng: 'to the TSD Investor Portal',
      link_login_th: 'https://ivp.tsd.co.th/signin?lang=th',
      link_login_eng: 'https://ivp.tsd.co.th/signin?lang=en',
      description_remark_section2_th:
        '<p>-  เมื่อเข้าระบบสำเร็จ เลือก “สอบถามข้อมูล”<br>-  เลือก “สิทธิ์การจองซื้อ”<br>-  ระบุปีที่ได้สิทธิการจองซื้อ แล้วกดปุ่ม Search</p>',
      description_remark_section2_eng:
        '<p>-  Select “Inquiries”<br>-  Select “Subscription rights”<br>-  Enter the year in which the subscription rights are granted and click the “Search” button</p>',
      remark_title_section3_th: '3. สอบถามผ่านเจ้าหน้าที่ SET Contact Center',
      remark_title_section3_eng: '3. SET Contact Center',
      description_remark_section3_th:
        '<p>โดยผู้ใช้งานต้องเตรียมข้อมูลดังนี้<br>-  ชื่อ นามสกุล และเลขที่บัตรประจำตัวประชาชน ของผู้ถือหลักทรัพย์ที่ประสงค์จะขอเลขทะเบียน<br>-  ชื่อหลักทรัพย์ที่ได้สิทธิซื้อหุ้นเพิ่มทุน<br>-  จำนวนยอดหุ้นเดิม หรือ จำนวนสิทธิใหม่ที่ได้รับในการจองซื้อหุ้นเพิ่มทุน</p>',
      description_remark_section3_eng:
        '<p>To use this channel, please prepare the following information<br>-  The name, surname, and identification number of the securities holder requesting the registration number<br>-  The name of the capital increase shares<br>-  The number of existing or new shares to which the securities holder has subscription rights</p>'
    },
    // Debentures of Inet หุ้นกู้ INET
    debentures_of_inet_page: {
      title_th: 'หุ้นกู้ INET 3/2569',
      title_eng: 'DEBENTURES OF INET NO. 3/2026',
      img_dot: 'assets/images/inetW2/dot.png',
      tranche_one: [
        {
          title_th: 'ชุดที่ 1',
          title_eng: 'Tranche No. 1',
          description_th: [
            'อายุ 2 ปี 3 เดือน 13 วัน',
            'อัตราดอกเบี้ย [5.25 - 5.35]% ต่อปี'
          ],
          description_eng: [
            'Tenor: 2 Years 3 Months 13 Days',
            'Coupon Rate: [5.25 - 5.35]% per annum'
          ]
        },
        {
          title_th: 'ชุดที่ 2',
          title_eng: 'Tranche No. 2',
          description_th: [
            'อายุ 3 ปี 2 เดือน',
            'อัตราดอกเบี้ย [5.45 - 5.65]% ต่อปี'
          ],
          description_eng: [
            'Tenor : 3 years 2 Months',
            'Coupon Rate: [5.45 - 5.65]% per annum'
          ]
        },
        {
          title_th: 'งวดการจ่ายดอกเบี้ย',
          title_eng: 'Interest Payment Schedule',
          description_th: ['จ่ายดอกเบี้ยทุก 3 เดือน'],
          description_eng: ['Quarterly']
        },
        {
          title_th: 'อันดับความน่าเชื่อถือ',
          title_eng: 'Credit Rating ',
          description_th: ['ไม่ได้จัดอันดับ (Non-rated)'],
          description_eng: ['Non-rated']
        },
        {
          title_th: 'ประเภทนักลงทุน*',
          title_eng: 'Distribution* ',
          description_th: ['ผู้ลงทุนประเภทสถาบัน และผู้ลงทุนรายใหญ่ (II/HNW)'],
          description_eng: [
            'Institutional Investors or High Net Worth Investors (II/HNW)'
          ]
        }
      ],
      subscription: [
        {
          title_th: 'การจองซื้อ',
          title_eng: 'Subscription',
          description_th: [
            'ตั้งแต่วันที่ 2 – 3 และ 6 กรกฎาคม 2569',
            'จองซื้อขั้นต่ำ 100,000 บาท (ทวีคูณครั้งละ 100,000 บาท)'
          ],
          description_eng: [
            '2 – 3 and 6 July 2026',
            'Minimum subscription amount of THB 100,000, with additional subscriptions in multiples of THB 100,000.'
          ]
        }
      ],
      underwriters: [
        {
          title_th: 'ผู้จัดจำหน่ายหุ้นกู้',
          title_eng: 'Underwriters',
          description_th: [
            'บริษัทหลักทรัพย์ หยวนต้า (ประเทศไทย) จำกัด <br>โทร 02-009-8351-56',
            'บริษัทหลักทรัพย์ ดาโอ (ประเทศไทย) จำกัด (มหาชน) <br>โทร 02-351-1800',
            'บริษัทหลักทรัพย์ บลูเบลล์ จำกัด <br>โทร 02-249-2999',
            'บริษัทหลักทรัพย์ เมอร์ชั่น พาร์ทเนอร์ จำกัด (มหาชน) <br>โทร 02-660-6688',
            'บริษัทหลักทรัพย์ เอเซีย พลัส จำกัด  <br>โทร 0-2680-4004',
            'บริษัทหลักทรัพย์ พาย จำกัด (มหาชน) <br>โทร 02-205-7387'
          ],
          description_eng: [
            'Yuanta Securities (Thailand) Company Limited <br>Tel. 02-009-8351-56',
            'Daol Securities (Thailand) Public Company Limited <br>Tel. 02-351-1800',
            'Bluebell Securities Company Limited <br>Tel. 02-249-2999',
            'Merchant Partners Securities Public Company Limited <br>Tel. 02-660-6688',
            'Asia Plus Securities Company Limited <br>Tel. 0-2680-4004',
            'Pi Securities Public Company Limited <br>Tel. 02-205-7387'
          ]
        }
      ],
      text_date_end_th: 'สิ้นสุดระยะเวลาเสนอขาย',
      text_date_end_eng: 'End of the offering period',
      // รายละเอียดหุ้นกู้
      title_detail_th: 'รายละเอียดหุ้นกู้',
      title_detail_eng: 'Description',
      img_title_detail: 'assets/images/inetW2/imgTitleDetail.jpg',
      // มีส่วนให้เพิ่มหลังบ้านแล้ว
      download_debentures_of_inet: [
        {
          title_th: 'สรุปข้อมูลสำคัญของตราสาร (Fact Sheet)',
          title_eng: 'Fact Sheet',
          link_th:
            'https://ir.inet.co.th/api/v1/file/5950782b-fbaf-43d4-bd89-9549ea525f07.pdf',
          link_eng:
            'https://ir.inet.co.th/api/v1/file/5950782b-fbaf-43d4-bd89-9549ea525f07.pdf'
        },
        {
          title_th: 'ข้อกำหนดสิทธิ',
          title_eng: 'Terms of rights',
          link_th:
            'https://ir.inet.co.th/api/v1/file/6652f529-2e4e-46bd-b643-f9dbc90f9f1d.pdf',
          link_eng:
            'https://ir.inet.co.th/api/v1/file/6652f529-2e4e-46bd-b643-f9dbc90f9f1d.pdf'
        }
      ],
      remark_title_th: 'หมายเหตุ',
      remark_title_eng: 'Remark',
      description_remark_th:
        'นิยามผู้ลงทุนสถาบันการเงิน และผู้ลงทุนรายใหญ่ ฉบับปรับปรุงล่าสุด มีผลบังคับใช้ 1 ตุลาคม 2565',
      description_remark_eng:
        'Investor definition as defined in SEC Kor Jor. 39/2564',
      link_remark_th:
        'https://www.sec.or.th/TH/Template3/Articles/2565/020365.pdf',
      link_remark_eng:
        'https://www.sec.or.th/TH/Template3/Articles/2565/020365.pdf',

      // warning
      warning_title_th: 'คำเตือน ',
      warning_title_eng: 'Warning ',
      description_warning_th:
        'การลงทุนมีความเสี่ยง โปรดศึกษารายละเอียดเกี่ยวกับเงื่อนไข ลักษณะของตราสารหนี้ ข้อมูลผู้ออกตราสารหนี้ และความเสี่ยง เพื่อให้มั่นใจว่าตราสารหนี้ดังกล่าวเหมาะสมกับเป้าหมายการลงทุนของท่านก่อนตัดสินใจลงทุน',
      description_warning_eng:
        'Investing involves risks. Please carefully review the terms, characteristics, issuer information, and risks of the debt securities to ensure they suit your investment goals before making a decision.',
      sub_description_th:
        'สามารถศึกษารายละเอียดเพิ่มเติมได้ในหนังสือชี้ชวนฉบับเต็มที่:',
      sub_description_eng:
        'Further details are available in the full prospectus at:',
      link_warning_th:
        'https://market.sec.or.th/public/ipos/IPOSDE01.aspx?TransID=764472',
      link_warning_eng:
        'https://market.sec.or.th/public/ipos/IPOSDE01.aspx?TransID=764472'
    },
    // corporateGovernance
    corporate_governance_page: {
      title_th: 'การกำกับดูแลกิจการ',
      title_eng: 'Corporate Governance',
      img_dot: 'assets/images/corporateGovernance/dot.png',
      img_build_inet: 'assets/images/corporateGovernance/build_inet.jpg',
      title_name_inet_th: 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)',
      title_name_inet_eng: 'Internet Thailand Public Company Limited',
      inet_description_th:
        'ตระหนักถึงความสำคัญของการกำกับดูแลกิจการ ซึ่งถือหลักในการสร้าง<br>ความเป็นธรรมแก่ผู้มีส่วนได้เสีย และเสริมสร้างองค์กรให้มีประสิทธิภาพ<br>จึงดำเนินการตามหลักการกำกับดูแลกิจการที่ดี มุ่งเน้นการสร้างประโยชน์ที่ดี<br>ให้แก่ผู้ถือหุ้น และคำนึงถึงผู้มีส่วนได้เสียโดยรวม<br>มีคุณธรรมในการดำเนินธุรกิจ มีความโปร่งใสและตรวจสอบได้',
      inet_description_eng:
        "realize the importance of corporate governance, which<br>focuses on equally treating the stakeholders and improving<br>the organization's efficiency. Therefore, the Board of Directors<br>and the Executives operate the Company in accordance with<br>the principle of corporate governance, with a focus on providing<br>profits to the shareholders while concerning all the stakeholders,<br>as well as doing business with solid integrity, transparency, and accountability.",
      inet_description_mobile_th:
        'ตระหนักถึงความสำคัญของการกำกับดูแลกิจการ ซึ่งถือหลักในการสร้างความเป็นธรรมแก่ผู้มีส่วนได้เสีย และเสริมสร้างองค์กรให้มีประสิทธิภาพ จึงดำเนินการตามหลักการกำกับดูแลกิจการที่ดี มุ่งเน้นการสร้างประโยชน์ที่ดีให้แก่ผู้ถือหุ้น และคำนึงถึงผู้มีส่วนได้เสียโดยรวม มีคุณธรรมในการดำเนินธุรกิจ มีความโปร่งใสและตรวจสอบได้',
      inet_description_mobile_eng:
        "realize the importance of corporate governance, which focuses on equally treating the stakeholders and improving the organization's efficiency. Therefore, the Board of Directors and the Executives operate the Company in accordance with the principle of corporate governance, with a focus on providing profits to the shareholders while concerning all the stakeholders, as well as doing business with solid integrity, transparency, and accountability.",
      cg_score: {
        img_file: [
          'assets/images/corporateGovernance/CGscore1.png',
          'assets/images/corporateGovernance/CGscore2.png',
          'assets/images/corporateGovernance/CGscore3.png',
          'assets/images/corporateGovernance/CGscore4.png',
          'assets/images/corporateGovernance/CGscore5.png'
        ],
        title_cg_score_th: 'CG Score',
        title_cg_score_eng: 'CG Score',
        description_th:
          'การประเมินผลการกำกับดูแลกิจการของบริษัทจดทะเบียนไทย<br>จาก โครงการสำรวจการกำกับดูแลกิจการบริษัทจดทะเบียนไทย<br>(Corporate Governance Report of Thai Listed Companies : CGR)<br>ของสมาคมส่งเสริมสถาบันกรรมการบริษัทไทย<br>(Thai Institute of Directors: IOD)',
        description_eng:
          'Corporate Governance Report of Thai Listed Companies by the Corporate Governance Report of Thai Listed Companies of the Thai Institutes of Directors.',
        description_mobile_th:
          'การประเมินผลการกำกับดูแลกิจการของบริษัทจดทะเบียนไทย จาก โครงการสำรวจการกำกับดูแลกิจการบริษัทจดทะเบียนไทย(Corporate Governance Report of Thai Listed Companies : CGR) ของสมาคมส่งเสริมสถาบันกรรมการบริษัทไทย(Thai Institute of Directors: IOD)',
        description_mobile_eng:
          'Corporate Governance Report of Thai Listed Companies by the Corporate Governance Report of Thai Listed Companies of the Thai Institutes of Directors.'
      },
      agm_score: {
        img_file: [
          'assets/images/corporateGovernance/AGMscore1.png',
          'assets/images/corporateGovernance/AGMscore2.png',
          'assets/images/corporateGovernance/AGMscore3.png',
          'assets/images/corporateGovernance/AGMscore4.png',
          'assets/images/corporateGovernance/AGMscore5.png'
        ],
        title_cg_score_th: 'AGM Score 2568',
        title_cg_score_eng: 'AGM Score 2025',
        description_th:
          'การประเมินคุณภาพการจัดประชุมสามัญผู้ถือหุ้น<br>จาก โครงการประเมินคุณภาพการจัดประชุมสามัญผู้ถือหุ้น<br>บริษัทจดทะเบียน (AGM Checklist) ของ สมาคมส่งเสริมผู้ลงทุนไทย<br>(Thai Investors Association: TIA) สมาคมบริษัทจดทะเบียน และ<br>สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ หรือ ก.ล.ต.',
        description_eng:
          'The Annual General Meeting of Shareholders Evaluation by the Thai Investor Association, Thai Listed Companies Association, and the SET.',
        description_mobile_th:
          'การประเมินคุณภาพการจัดประชุมสามัญผู้ถือหุ้น จาก โครงการประเมินคุณภาพการจัดประชุมสามัญผู้ถือหุ้น บริษัทจดทะเบียน (AGM Checklist) ของ สมาคมส่งเสริมผู้ลงทุนไทย(Thai Investors Association: TIA) สมาคมบริษัทจดทะเบียน และสำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ หรือ ก.ล.ต.',
        description_mobile_eng:
          'The Annual General Meeting of Shareholders Evaluation by the Thai Investor Association, Thai Listed Companies Association, and the SET.'
      },
      cac_section: {
        img_logo_cac: 'assets/images/corporateGovernance/CAC_link.png',
        title_cac_th: 'การต่อต้านการทุจริตและคอร์รัปชัน : CAC',
        title_cac_eng: 'Anti–Corruption : CAC'
      },
      esg_section: {
        img_logo_esg: 'assets/images/corporateGovernance/ESG_link.png',
        title_esg_th: 'การจัดการความยั่งยืน : ESG',
        title_esg_eng: 'Sustainability Management : ESG'
      },
      governance_policy: {
        title_th: 'นโยบายที่เกี่ยวข้อง',
        title_eng: 'Governance Policy'
      },
      download_governance_policy: []
    },
    // cacPage
    cac_page: {
      title_th: 'การต่อต้านการทุจริตและคอร์รัปชัน : CAC',
      title_eng: 'Anti–Corruption : CAC',
      img_dot: 'assets/images/cacPage/dot.png',
      img_logo_CAC: 'assets/images/cacPage/logoCAC.png',
      title_inet_th: 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)',
      title_inet_eng: 'Internet Thailand Public Company Limited',
      description_th:
        'มีอุดมการณ์ในการดำเนินธุรกิจอย่างโปร่งใส และมีคุณธรรม<br>โดยยึดมั่นใน ความรับผิดชอบต่อสังคมและผู้มีส่วนได้เสียทุกกลุ่ม<br>ตามหลักการกำกับดูแลกิจการที่ดี และจรรยาบรรณทางธุรกิจ<br>ตลอดจนนโยบายและแนวทางปฏิบัติต่อผู้มีส่วน ได้เสียกลุ่มต่างๆ<br>ของบริษัทฯ ในปี 2557 บริษัทฯ ได้เข้าร่วม “แนวร่วมปฏิบัติของ<br>ภาคเอกชนไทยในการต่อต้านการทุจริต” เพื่อแสดงเจตนารมณ์<br>และความมุ่งมั่น ในการต่อต้านการคอร์รัปชันในทุกรูปแบบ',
      description_eng:
        'The Company adheres to social responsibility and all groups<br>of stakeholders with the principles of good corporate governance,<br>business ethics, as well as policies and guidelines for various groups<br>of stakeholders of the Company. To intents and commitment<br>to anti-corruption in all formats.',
      description_mobile_th:
        'มีอุดมการณ์ในการดำเนินธุรกิจอย่างโปร่งใส และมีคุณธรรม โดยยึดมั่นใน ความรับผิดชอบต่อสังคมและผู้มีส่วนได้เสียทุกกลุ่มตามหลักการกำกับดูแลกิจการที่ดี และจรรยาบรรณทางธุรกิจ ตลอดจนนโยบายและแนวทางปฏิบัติต่อผู้มีส่วน ได้เสียกลุ่มต่างๆ ของบริษัทฯ ในปี 2557 บริษัทฯ ได้เข้าร่วม “แนวร่วมปฏิบัติของ ภาคเอกชนไทยในการต่อต้านการทุจริต” เพื่อแสดงเจตนารมณ์และความมุ่งมั่น ในการต่อต้านการคอร์รัปชันในทุกรูปแบบ',
      description_mobile_eng:
        'The Company adheres to social responsibility and all groups of stakeholders with the principles of good corporate governance, business ethics, as well as policies and guidelines for various groups of stakeholders of the Company. To intents and commitment to anti-corruption in all formats.'
    },
    complaint_channels: {
      title_th: 'ช่องทางการร้องเรียน',
      title_eng: 'Complaint Channels',
      description_p1_th:
        'แจ้งผ่านช่องทางการแจ้งข้อร้องเรียน และเบาะแสทางหน้าเว็บไซต์ของบริษัทฯ',
      description_p1_eng:
        'By submitting the complaint and information via the company’s website',
      web_th: 'inet.co.th/whistleblowing',
      web_eng: 'inet.co.th/whistleblowing',
      description_p2_th:
        'กรณีต้องการสอบถาม ขอคำปรึกษาคำแนะนำ / ในการปฏิบัติตามมาตรการต่อต้านการคอร์รัปชัน สามารถติดต่อได้ทาง E-Mail',
      description_p2_eng:
        'In case of questions and advice on compliance with anti – corruption standards, contact',
      mail: 'inet-cac@inet.co.th',
      description_p3_th:
        'ส่งจดหมายถึงผู้รับข้อร้องเรียน ที่ ประธานกรรมการตรวจสอบ หรือประธานกรรมการสรรหา กำหนดค่าตอบแทน กำกับดูแลกิจการและความยั่งยืน หรือ เลขานุการคณะกรรมการบริษัท หรือ ผู้บริหารสำนักตรวจสอบภายใน หรือผู้บริหารฝ่ายทรัพยากรบุคคล ดังตัวอย่าง',
      description_p3_eng:
        'Or by sending a mail to the designated complaint handlers, namely, the chairman of the Audit Committee, the Nomination, Remuneration, Corporate Governance and Sustainability Committee, the Company Secretary, the Head of the Internal Audit Department, and the Head of the Human Resource Department, for example.',
      title_p4_th: 'เรียน ประธานกรรมการตรวจสอบ',
      title_p4_eng: 'Attention Chairman of the Audit Committee',
      description_p4_th:
        'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)<br>1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT<br>ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง<br>กรุงเทพมหานคร 10310',
      description_p4_eng:
        'Internet Thailand Public Company Limited<br>1768, Thai Summit Tower, 10th-12th Flr. and IT Flr.<br>New Petchburi Road, Bangkapi,Huai Khwang, Bangkok, 10310',
      description_p4_mobile_th:
        'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310',
      description_p4_mobile_eng:
        'Internet Thailand Public Company Limited 1768, Thai Summit Tower, 10th-12th Flr. and IT Flr. New Petchburi Road, Bangkapi Sub-district,Huai Khwang District, Bangkok, 10310',
      img_contact: 'assets/images/cacPage/contact.png',
      img_mail: 'assets/images/cacPage/mail.png',
      img_web: 'assets/images/cacPage/lock.png'
    },
    // managementTeam
    management_team_page: {
      title_th: 'คณะกรรมการบริษัท',
      title_eng: 'Board of Directors',
      title_section2_th: 'ผู้บริหารบริษัท',
      title_section2_eng: 'Management Team',
      img_dot: 'assets/images/managementTeam/dot.png',
      list_team_all: [
        {
          title_th: 'คณะกรรมการบริษัท',
          title_eng: 'Board of Directors',
          tag: 'BoardOfDirectors'
        },
        {
          title_th: 'คณะกรรมการบริหาร',
          title_eng: 'The Executive Committee',
          tag: 'TheExecutiveCommittee'
        },
        {
          title_th: 'คณะกรรมการตรวจสอบ',
          title_eng: 'The Audit Committee',
          tag: 'TheAuditCommittee'
        },
        {
          title_th:
            'คณะกรรมการสรรหา กำหนดค่าตอบแทน กำกับดูแลกิจการและความยั่งยืน',
          title_eng:
            'Nomination, Remuneration, Corporate Governance and Sustainability Committee',
          tag: 'TheNominationRemunerationAndCorporateGovernanceCommittee'
        },
        {
          title_th: 'คณะกรรมการการบริหารความเสี่ยง',
          title_eng: 'The Risk Management Committee',
          tag: 'TheRiskManagementCommittee'
        },
        {
          title_th: 'คณะกรรมการประเมินผลการปฏิบัติงานของกรรมการผู้จัดการ',
          title_eng: 'The CEO Performance Review Committee',
          tag: 'TheCEOPerformanceReviewCommittee'
        },
        {
          title_th: 'คณะกรรมการเทคโนโลยี',
          title_eng: 'Technology Committee',
          tag: 'TechnologyCommittee'
        },
        {
          title_th: 'คณะกรรมการลงทุนและบริหารเงิน',
          title_eng: 'Investment and Treasury Management Committee',
          tag: 'InvestmentAndTreasuryManagementCommittee'
        }
      ],
      btn_close_th: 'ปิด',
      btn_close_eng: 'close',
      // title dialog
      title_age_th: 'อายุ',
      unit_age_th: 'ปี',
      unit_age_eng: 'years',
      title_age_eng: 'Age',
      title_position_th: 'ตำแหน่งในบริษัท',
      title_position_eng: 'Position',
      title_start_position_th: 'วันที่ได้รับแต่งตั้งเป็นกรรมการ',
      title_start_position_eng: 'Date of appointment',
      title_educational_th: 'คุณวุฒิการศึกษา',
      title_educational_eng: 'Education',
      title_volume_th: 'จำนวนหุ้นที่ถือหุ้นในบริษัท',
      title_volume_eng: 'Number of shares',
      unit_volume_th: 'หุ้น',
      unit_volume_eng: 'Share',
      title_ratio_th: 'สัดส่วนการถือหุ้นในบริษัท',
      title_ratio_eng: 'Percentage of Shareholding',
      title_relationship_th:
        'ความสัมพันธ์ทางครอบครัวระหว่างกรรมการและผู้บริหาร',
      title_relationship_eng: 'Relationship between directors and executives',
      title_status_yes_th: 'มี',
      title_status_yes_eng: 'Yes',
      title_status_no_th: 'ไม่มี',
      title_status_no_eng: 'None'
    },
    // esgPage
    esg_page: {
      title_th: 'การจัดการความยั่งยืน : ESG',
      title_eng: 'Sustainability Management : ESG',
      img_dot: 'assets/images/esgPage/dot.png',
      img_logo_CAC: 'assets/images/esgPage/GoalLogo.png',
      title_description_th: 'นโยบายการจัดการความยั่งยืนระดับองค์กร',
      title_description_eng: 'Organizational Sustainability Management Policy',
      description_th:
        'บริษัทมุ่งสร้างนวัตกรรมเทคโนโลยีสารสนเทศและบริการทางด้านเทคโนโลยีดิจิทัลให้เกิดการบูรณการกับวัฒนธรรมองค์กร ซึ่งมีการพัฒนาอย่างต่อเนื่อง และยึดมั่นในหลักการกำกับดูแลกิจการที่ดี สร้างคุณค่าระยะยาวกับเศรษฐกิจ สังคม และสิ่งแวดล้อม ให้สอดคล้องกับเป้าหมายการพัฒนาที่ยั่งยืน (SDGs) รวมถึงตระหนักถึงความสำคัญของผู้มีส่วนได้เสียทุกภาคส่วน สร้างความสมดุลและเติบโตร่วมกันอย่างยั่งยืน',
      description_eng:
        'The company develops innovative IT and digital services, integrating them into its culture with ongoing improvements. Committed to good governance, it creates long-term value for the economy, society, and the environment, supporting the Sustainable Development Goals (SDGs). The company values all stakeholders, ensuring balance and fostering sustainable growth together',
      description_mobile_th:
        'บริษัทมุ่งสร้างนวัตกรรมเทคโนโลยีสารสนเทศและบริการทางด้านเทคโนโลยีดิจิทัลให้เกิดการบูรณการกับวัฒนธรรมองค์กร ซึ่งมีการพัฒนาอย่างต่อเนื่อง และยึดมั่นในหลักการกำกับดูแลกิจการที่ดี สร้างคุณค่าระยะยาวกับเศรษฐกิจ สังคม และสิ่งแวดล้อม ให้สอดคล้องกับเป้าหมายการพัฒนาที่ยั่งยืน (SDGs) รวมถึงตระหนักถึงความสำคัญของผู้มีส่วนได้เสียทุกภาคส่วน สร้างความสมดุลและเติบโตร่วมกันอย่างยั่งยืน',
      description_mobile_eng:
        'The company develops innovative IT and digital services, integrating them into its culture with ongoing improvements. Committed to good governance, it creates long-term value for the economy, society, and the environment, supporting the Sustainable Development Goals (SDGs). The company values all stakeholders, ensuring balance and fostering sustainable growth together',
      title_dimension_th: 'เป้าหมายการจัดการความยั่งยืนระดับองค์กร',
      title_dimension_eng: 'Organizational Sustainability Management Goals',
      image_targetDimension_eng:
        'assets/images/esgPage/targetDimension_eng.png',
      image_targetDimension_th: 'assets/images/esgPage/targetDimension_th.png'
    },
    economy: {
      img_title: 'assets/images/esgPage/economyText.png',
      img_background_title: 'assets/images/esgPage/economyBackgroundNew.jpg',
      img_background_title_th:
        'assets/images/esgPage/economyBackgroundNew_th.jpg',
      img_background_title_eng:
        'assets/images/esgPage/economyBackgroundNew_eng.jpg',
      text_page_th: 'หน้า',
      text_page_eng: 'Page',
      image_economy_th: 'assets/images/esgPage/economy_detail_th.png',
      image_economy_eng: 'assets/images/esgPage/economy_detail_eng.png',
      btn_close_th: 'ปิด',
      btn_close_eng: 'close',
      sub_economy: [
        {
          img_sub: 'assets/images/esgPage/economy1.png',
          titile_sub_th:
            'ดำเนินธุรกิจของบริษัทและบริษัทในเครือให้เติบโตอย่างยั่งยืน',
          titile_sub_eng:
            'The Company and its subsidiaries conduct business sustainably.'
        },
        {
          img_sub: 'assets/images/esgPage/economy2.png',
          titile_sub_th: 'บริหารงานด้วยหลักธรรมาภิบาลที่ดี',
          titile_sub_eng: 'Operate with good governance principles.'
        },
        {
          img_sub: 'assets/images/esgPage/economy3.png',
          titile_sub_th:
            'มุ่งสร้างคุณค่าให้กับผู้มีส่วนได้เสียทุกฝ่ายที่เกี่ยวข้องกับการดำเนินธุรกิจ',
          titile_sub_eng:
            'Aim to create value for all stakeholders involved in business operations.'
        },
        {
          img_sub: 'assets/images/esgPage/economy4.png',
          titile_sub_th: 'ก่อให้เกิดรายได้หมุนเวียนในระบบเศรษฐกิจ',
          titile_sub_eng: 'Generate revolving income in the economic system.'
        },
        {
          img_sub: 'assets/images/esgPage/economy5.png',
          titile_sub_th:
            'ส่งเสริมการท่องเที่ยวเมืองรองเพื่อลดการกระจุกตัวของเงินหมุนเวียนในระบบเศรษฐกิจ',
          titile_sub_eng:
            'Promote secondary city tourism to reduce concentration of working capital in the economic system.'
        },
        {
          img_sub: 'assets/images/esgPage/economy6.png',
          titile_sub_th:
            'ส่งเสริมและขยายการเข้าถึงธนาคาร ประกัน และบริการทางการเงินแก่ทุกคน',
          titile_sub_eng:
            'Promote and expand access to banking, insurance, and financial services for everyone.'
        },
        {
          img_sub: 'assets/images/esgPage/economy7.png',
          titile_sub_th:
            'เสริมศักยภาพของธุรกิจ คิดค้นและพัฒนานวัตกรรมใหม่ๆ เพื่อตอบสนองทุกธุรกิจและสังคมที่มีการเปลี่ยนแปลงอยู่ตลอดเวลา',
          titile_sub_eng:
            'Strengthen business capabilities, innovate, and develop new technologies to meet the changing needs of businesses and society.'
        }
      ],
      sub_environment: [
        {
          img_sub: 'assets/images/esgPage/environment1.png',
          titile_sub_th:
            'ใช้พลังงานอย่างมีประสิทธิภาพและส่งเสริมการใช้พลังงานทดแทน',
          titile_sub_eng:
            'Use energy efficiently and promote the use of renewable energy.'
        },
        {
          img_sub: 'assets/images/esgPage/environment2.png',
          titile_sub_th:
            'ตระหนักถึงทรัพยากรธรรมชาติที่มีอยู่อย่างจำกัดเพื่อบรรลุการจัดการที่ยั่งยืน และการใช้ทรัพยากรธรรมชาติอย่างมีประสิทธิภาพ',
          titile_sub_eng:
            'Acknowledge the limited natural resources to achieve sustainable management and efficient use of natural resources.'
        },
        {
          img_sub: 'assets/images/esgPage/environment3.png',
          titile_sub_th:
            'ป้องกัน ควบคุม และลดผลกระทบต่อสิ่งแวดล้อมจากการดำเนินธุรกิจของบริษัท และบริษัทในเครือ',
          titile_sub_eng:
            'Support the use of clean and renewable energy that do not emit carbon dioxide.'
        },
        {
          img_sub: 'assets/images/esgPage/environment4.png',
          titile_sub_th:
            'สนับสนุนการใช้พลังงานที่สะอาด เป็นพลังงานทดแทนไม่ก่อให้เกิดการปล่อยก๊าซคาร์บอนไดออกไซด์',
          titile_sub_eng:
            'Prevent, control, and reduce environmental impacts as a result from operations of the Company and its subsidiaries.'
        }
      ],
      sub_society: [
        {
          img_sub: 'assets/images/esgPage/society1.png',
          titile_sub_th:
            'ส่งเสริมพนักงานให้มีความเป็นอยู่ที่ดี ได้รับโอกาสในการพัฒนาและมีความก้าวหน้าในการทำงาน',
          titile_sub_eng:
            'Promote good working conditions for employees and provide opportunities for career development and advancement.'
        },
        {
          img_sub: 'assets/images/esgPage/society2.png',
          titile_sub_th: 'ส่งเสริมเกษตรกรรมที่ยั่งยืนด้วยความรู้และเทคโนโลยี',
          titile_sub_eng:
            'Promote sustainable agriculture with knowledge and technology.'
        },
        {
          img_sub: 'assets/images/esgPage/society3.png',
          titile_sub_th: 'สร้างงาน สร้างรายได้ สร้างอาชีพให้กับร้านค้าในชุมชน',
          titile_sub_eng: 'Facilitate and improve healthcare services.'
        },
        {
          img_sub: 'assets/images/esgPage/society4.png',
          titile_sub_th:
            'ส่งเสริมสนับสนุนบริการทางการเงินแก่วิสาหกิจขนาดเล็กและขนาดกลาง',
          titile_sub_eng:
            'Support financial, services for small and medium-sized enterprises.'
        },
        {
          img_sub: 'assets/images/esgPage/society5.png',
          titile_sub_th:
            'สนับสนุนการพัฒนาการอย่างยั่งยืนของชุมชนและสังคมในทุกพื้นที่ที่บริษัทและบริษัทในเครือเข้าไปประกอบกิจการ',
          titile_sub_eng:
            'Create jobs, income, and career for businesses in the community.'
        },
        {
          img_sub: 'assets/images/esgPage/society6.png',
          titile_sub_th:
            'สนับสนุนโอกาสอย่างเท่าเทียมแก่สตรีในการพิจารณาสรรหาบุคคลเป็นกรรมการ ซึ่งบริษัทมีจำนวนกรรมการสตรีไม่น้อยกว่าร้อยละ 30 ของจำนวนกรรมการทั้งหมดของบริษัท',
          titile_sub_eng:
            'Support equal opportunities for women when appointing board members, the Company has at least 30% female board members of the total board members.'
        },
        {
          img_sub: 'assets/images/esgPage/society7.png',
          titile_sub_th: 'อำนวยความสะดวกในการให้บริการสาธารณสุขเพิ่มขึ้น',
          titile_sub_eng:
            'Support sustainable development of communities and societies in all areas where the Company and its subsidiaries operate.'
        },
        {
          img_sub: 'assets/images/esgPage/society8.png',
          titile_sub_th:
            'ส่งเสริมการมีสุขภาพและความเป็นอยู่ที่ดี ประชาชนสามารถเข้าถึงบริการด้านสุขภาพอย่างเท่าเทียม',
          titile_sub_eng:
            'Promote healthy and good well-being by ensuring equal access to healthcare services.'
        },
        {
          img_sub: 'assets/images/esgPage/society9.png',
          titile_sub_th: 'ส่งเสริมการศึกษาและการเรียนรู้แก่ทุกคน',
          titile_sub_eng: 'Promote education and learning for all.'
        },
        {
          img_sub: 'assets/images/esgPage/society10.png',
          titile_sub_th:
            'สันติภาพ ยุติธรรม และสถาบันที่เข้มแข็ง ลดการทุจริตคอร์รัปชัน พัฒนาสถาบันที่มีประสิทธิภาพ โปร่งใส',
          titile_sub_eng:
            'Promote peace, justice, and strong institutions.Reduce corruption and develop effective and transparent institutions.'
        },
        {
          img_sub: 'assets/images/esgPage/society11.png',
          titile_sub_th:
            'สนับสนุนการเข้าถึงอาหารที่ปลอดภัย มีโภชนาการและเพียงพอ เพื่อช่วยลดการแพร่กระจายของเชื้อโควิด',
          titile_sub_eng:
            'Promote access to safe and nutritious food to help reduce the spread of COVID-19.'
        }
      ]
    },
    environment: {
      img_title: 'assets/images/esgPage/environmentText.png',
      img_background_title:
        'assets/images/esgPage/environmentBackgroundNew.jpg',
      img_background_title_th:
        'assets/images/esgPage/environmentBackgroundNew_th.jpg',
      img_background_title_eng:
        'assets/images/esgPage/environmentBackgroundNew_eng.jpg',
      text_page_th: 'หน้า',
      text_page_eng: 'Page',
      image_environment_th: 'assets/images/esgPage/environment_detail_th.png',
      image_environment_eng: 'assets/images/esgPage/environment_detail_eng.png',
      btn_close_th: 'ปิด',
      btn_close_eng: 'close',
      sub_environment: [
        {
          img_sub: 'assets/images/esgPage/environment1.png',
          titile_sub_th:
            'ใช้พลังงานอย่างมีประสิทธิภาพและส่งเสริมการใช้พลังงานทดแทน',
          titile_sub_eng:
            'Use energy efficiently and promote the use of renewable energy.'
        },
        {
          img_sub: 'assets/images/esgPage/environment2.png',
          titile_sub_th:
            'ตระหนักถึงทรัพยากรธรรมชาติที่มีอยู่อย่างจำกัดเพื่อบรรลุการจัดการที่ยั่งยืน และการใช้ทรัพยากรธรรมชาติอย่างมีประสิทธิภาพ',
          titile_sub_eng:
            'Acknowledge the limited natural resources to achieve sustainable management and efficient use of natural resources.'
        },
        {
          img_sub: 'assets/images/esgPage/environment3.png',
          titile_sub_th:
            'ป้องกัน ควบคุม และลดผลกระทบต่อสิ่งแวดล้อมจากการดำเนินธุรกิจของบริษัท และบริษัทในเครือ',
          titile_sub_eng:
            'Support the use of clean and renewable energy that do not emit carbon dioxide.'
        },
        {
          img_sub: 'assets/images/esgPage/environment4.png',
          titile_sub_th:
            'สนับสนุนการใช้พลังงานที่สะอาด เป็นพลังงานทดแทนไม่ก่อให้เกิดการปล่อยก๊าซคาร์บอนไดออกไซด์',
          titile_sub_eng:
            'Prevent, control, and reduce environmental impacts as a result from operations of the Company and its subsidiaries.'
        }
      ]
    },
    society: {
      img_title: 'assets/images/esgPage/societyText.png',
      img_background_title: 'assets/images/esgPage/societyBackgroundNew.jpg',
      img_background_title_th:
        'assets/images/esgPage/societyBackgroundNew_th.jpg',
      img_background_title_eng:
        'assets/images/esgPage/societyBackgroundNew_eng.jpg',
      text_page_th: 'หน้า',
      text_page_eng: 'Page',
      image_society_th: 'assets/images/esgPage/society_detail_th.png',
      image_society_eng: 'assets/images/esgPage/society_detail_eng.png',
      btn_close_th: 'ปิด',
      btn_close_eng: 'close',
      sub_society: [
        {
          img_sub: 'assets/images/esgPage/society1.png',
          titile_sub_th:
            'ส่งเสริมพนักงานให้มีความเป็นอยู่ที่ดี ได้รับโอกาสในการพัฒนาและมีความก้าวหน้าในการทำงาน',
          titile_sub_eng:
            'Promote good working conditions for employees and provide opportunities for career development and advancement.'
        },
        {
          img_sub: 'assets/images/esgPage/society2.png',
          titile_sub_th: 'ส่งเสริมเกษตรกรรมที่ยั่งยืนด้วยความรู้และเทคโนโลยี',
          titile_sub_eng:
            'Promote sustainable agriculture with knowledge and technology.'
        },
        {
          img_sub: 'assets/images/esgPage/society3.png',
          titile_sub_th: 'สร้างงาน สร้างรายได้ สร้างอาชีพให้กับร้านค้าในชุมชน',
          titile_sub_eng: 'Facilitate and improve healthcare services.'
        },
        {
          img_sub: 'assets/images/esgPage/society4.png',
          titile_sub_th:
            'ส่งเสริมสนับสนุนบริการทางการเงินแก่วิสาหกิจขนาดเล็กและขนาดกลาง',
          titile_sub_eng:
            'Support financial, services for small and medium-sized enterprises.'
        },
        {
          img_sub: 'assets/images/esgPage/society5.png',
          titile_sub_th:
            'สนับสนุนการพัฒนาการอย่างยั่งยืนของชุมชนและสังคมในทุกพื้นที่ที่บริษัทและบริษัทในเครือเข้าไปประกอบกิจการ',
          titile_sub_eng:
            'Create jobs, income, and career for businesses in the community.'
        },
        {
          img_sub: 'assets/images/esgPage/society6.png',
          titile_sub_th:
            'สนับสนุนโอกาสอย่างเท่าเทียมแก่สตรีในการพิจารณาสรรหาบุคคลเป็นกรรมการ ซึ่งบริษัทมีจำนวนกรรมการสตรีไม่น้อยกว่าร้อยละ 30 ของจำนวนกรรมการทั้งหมดของบริษัท',
          titile_sub_eng:
            'Support equal opportunities for women when appointing board members, the Company has at least 30% female board members of the total board members.'
        },
        {
          img_sub: 'assets/images/esgPage/society7.png',
          titile_sub_th: 'อำนวยความสะดวกในการให้บริการสาธารณสุขเพิ่มขึ้น',
          titile_sub_eng:
            'Support sustainable development of communities and societies in all areas where the Company and its subsidiaries operate.'
        },
        {
          img_sub: 'assets/images/esgPage/society8.png',
          titile_sub_th:
            'ส่งเสริมการมีสุขภาพและความเป็นอยู่ที่ดี ประชาชนสามารถเข้าถึงบริการด้านสุขภาพอย่างเท่าเทียม',
          titile_sub_eng:
            'Promote healthy and good well-being by ensuring equal access to healthcare services.'
        },
        {
          img_sub: 'assets/images/esgPage/society9.png',
          titile_sub_th: 'ส่งเสริมการศึกษาและการเรียนรู้แก่ทุกคน',
          titile_sub_eng: 'Promote education and learning for all.'
        },
        {
          img_sub: 'assets/images/esgPage/society10.png',
          titile_sub_th:
            'สันติภาพ ยุติธรรม และสถาบันที่เข้มแข็ง ลดการทุจริตคอร์รัปชัน พัฒนาสถาบันที่มีประสิทธิภาพ โปร่งใส',
          titile_sub_eng:
            'Promote peace, justice, and strong institutions.Reduce corruption and develop effective and transparent institutions.'
        },
        {
          img_sub: 'assets/images/esgPage/society11.png',
          titile_sub_th:
            'สนับสนุนการเข้าถึงอาหารที่ปลอดภัย มีโภชนาการและเพียงพอ เพื่อช่วยลดการแพร่กระจายของเชื้อโควิด',
          titile_sub_eng:
            'Promote access to safe and nutritious food to help reduce the spread of COVID-19.'
        }
      ]
    },
    // financialInformationPage
    financial_page: {
      title_th: 'ข้อมูลทางการเงิน',
      title_eng: 'Financial Information',
      img_dot: 'assets/images/financialInformation/dot.png',
      title_download_th: 'งบการเงิน',
      title_download_eng: 'Financial Statement',
      title_year_th: 'ปี',
      title_year_eng: 'Year',
      img_background: 'assets/images/financialInformation/background.jpg',
      img_financial:
        'assets/images/financialInformation/FinancialStatement.jpg',
      btn_view_th: 'ย้อนหลังเพิ่มเติม',
      btn_view_eng: 'More Retrospectives',
      // tableFinancialHighlights
      // headerTable
      title_table_highlights_th: 'บัญชีทางการเงินที่สำคัญ',
      title_table_highlights_eng: 'Financial Highlights',
      title_chart_assets_th: 'สินทรัพย์รวม',
      title_chart_assets_eng: 'Total Assets',
      title_chart_liabilities_th: 'หนี้สินรวม',
      title_chart_liabilities_eng: 'Total Liabilities',
      title_chart_revenues_th: 'รายได้รวม',
      title_chart_revenues_eng: 'Total Revenues',
      title_chart_net_profit_th: 'กำไร (ขาดทุน) สุทธิ',
      title_chart_net_profit_eng: 'Net Profit',
      unit_chart_th: 'ล้านบาท',
      unit_chart_eng: 'Million Baht',
      header_table_financial_highlights_th: [],
      header_table_financial_highlights_eng: [],
      itmes_table_financial_highlights: [],
      // tableFinancialRatio
      title_table_Ratio_th: 'อัตราส่วนทางการเงินที่สำคัญ',
      title_table_Ratio_eng: 'Financial Ratio',
      // headerTable
      header_table_financial_ratio_th: [],
      header_table_financial_ratio_eng: [],
      items_table_financial_ratio: [],
      title_origin_th: 'ที่มา : ตลาดหลักทรัพย์แห่งประเทศไทย',
      title_origin_eng: 'Source: Stock Exchange of Thailand',
      link_set_th:
        'www.set.or.th/th/market/product/stock/quote/INET/financial-statement/company-highlights',
      link_set_eng:
        'www.set.or.th/en/market/product/stock/quote/INET/financial-statement/company-highlights'
    },
    // mdAndAPage
    md_and_a_page: {
      title_th: 'คำอธิบายและบทวิเคราะห์ของฝ่ายจัดการ MD&A',
      title_eng: 'MD&A',
      img_dot: 'assets/images/financialInformation/dot.png',
      title_download_th: 'คำอธิบายและบทวิเคราะห์ของฝ่ายจัดการ',
      title_download_eng: 'MD&A',
      title_year_th: 'ปี',
      title_year_eng: 'Year',
      img_background: 'assets/images/mdAndA/background.jpg',
      img_financial: 'assets/images/mdAndA/MDandA.jpg'
    },
    // dividendPolicy
    dividend_policy_page: {
      title_th: 'นโยบายการจ่ายเงินปันผล',
      title_eng: 'Dividend Policy',
      img_dot: 'assets/images/dividendPolicy/dot.png',
      img_background: 'assets/images/dividendPolicy/backgroundSection1.png',
      description_th:
        'บริษัทมีนโยบายการจ่ายเงินปันผลในอัตราไม่ต่ำกว่าร้อยละ 30 ของกำไรสุทธิของบริษัท<br>หลังหักภาษีหากไม่มีเหตุจำเป็นอื่นใด โดยขึ้นอยู่กับสภาวะเศรษฐกิจและโครงการ<br>ดำเนินธุรกิจในอนาคตของบริษัทและบริษัทย่อย และการจ่ายเงินปันผลนั้น<br>ไม่มีผลกระทบต่อการดำเนินงานปกติของบริษัท',
      description_eng:
        "The Company’s dividend policy is to pay dividend no less than 30%<br>of profit after tax, if the fund is not required elsewhere and subject to<br>the economic and future project of the Company and its subsidiary and<br>the payment would have no significant effect on the company's normal operation",
      description_mobile_th:
        'บริษัทมีนโยบายการจ่ายเงินปันผลในอัตราไม่ต่ำกว่าร้อยละ 30 ของกำไรสุทธิของบริษัทหลังหักภาษีหากไม่มีเหตุจำเป็นอื่นใด โดยขึ้นอยู่กับสภาวะเศรษฐกิจและโครงการดำเนินธุรกิจในอนาคตของบริษัทและบริษัทย่อย และการจ่ายเงินปันผลนั้นไม่มีผลกระทบต่อการดำเนินงานปกติของบริษัท',
      description_mobile_eng:
        "The Company’s dividend policy is to pay dividend no less than 30% of profit after tax, if the fund is not required elsewhere and subject to the economic and future project of the Company and its subsidiary and the payment would have no significant effect on the company's normal operation",
      title_table_payment_info_th: 'ข้อมูลการจ่ายเงินปันผลของบริษัท',
      title_table_payment_info_eng: 'The Company’s Dividend Payment Info',
      text_no_dividend_th: 'งดจ่ายเงินปันผล',
      text_no_dividend_eng: 'no dividend payment',
      header_table_payment_info_eng: [
        {
          text: 'Year',
          align: 'center',
          sortable: false,
          value: 'year'
        },
        {
          text: 'Dividend per share (baht)',
          align: 'center',
          sortable: false,
          value: 'dividend_per_share'
        },
        {
          text: 'Dividend in total (million baht)',
          align: 'center',
          sortable: false,
          value: 'dividend_in_total'
        },
        {
          text: 'Dividend per net profit (%)',
          align: 'center',
          sortable: false,
          value: 'dividend_per_net_profit'
        }
      ],
      header_table_payment_info_th: [
        {
          text: 'ปี',
          align: 'center',
          sortable: false,
          value: 'year'
        },
        {
          text: 'จ่ายเงินปันผลประจำปี อัตราหุ้นละ (บาท)',
          align: 'center',
          sortable: false,
          value: 'dividend_per_share'
        },
        {
          text: 'คิดเป็นเงินปันผลจำนวน (ล้านบาท)',
          align: 'center',
          sortable: false,
          value: 'dividend_in_total'
        },
        {
          text: 'อัตราการจ่ายเงินปันผลต่อกำไรสุทธิ (%)',
          align: 'center',
          sortable: false,
          value: 'dividend_per_net_profit'
        }
      ],
      items_table_payment_info: []
    },
    // shareholdingStructure
    shareholding_structure_page: {
      title_th: ' โครงสร้างผู้ถือหุ้น',
      title_eng: 'Shareholder Structure',
      img_dot: 'assets/images/shareholdingStructure/dot.png',
      img_shareholder_structure_th:
        'assets/images/shareholdingStructure/ShareholderStructure_th.png',
      img_shareholder_structure_eng:
        'assets/images/shareholdingStructure/ShareholderStructure_eng.png',
      title_table_top_10_shareholders_th:
        'รายชื่อผู้ถือหลักทรัพย์ตั้งแต่ 0.5% ของบริษัท',
      title_table_top_10_shareholders_eng:
        'The list of securities holders holding equal to or more than 0.5%',
      remark_th: 'ณ วันที่ 10 มีนาคม 2566',
      remark_eng: 'as of March 10, 2023',
      header_table_top_10_shareholders_th: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'rank'
        },
        {
          text: 'ชื่อ',
          align: 'start',
          sortable: false,
          value: 'shareholders'
        },
        {
          text: 'จำนวนหุ้น',
          align: 'center',
          sortable: false,
          value: 'shares'
        },
        {
          text: '% ของจำนวนหุ้น',
          align: 'center',
          sortable: false,
          value: 'shares_percentage'
        }
      ],
      header_table_top_10_shareholders_eng: [
        {
          text: 'Rank',
          align: 'center',
          sortable: false,
          value: 'rank'
        },
        {
          text: 'Shareholders',
          align: 'start',
          sortable: false,
          value: 'shareholders'
        },
        {
          text: '# Shares (Shares)',
          align: 'center',
          sortable: false,
          value: 'shares'
        },
        {
          text: '% Shares',
          align: 'center',
          sortable: false,
          value: 'shares_percentage'
        }
      ],
      items_table_top_10_shareholders: [],
      title_origin_th: 'ที่มา : ตลาดหลักทรัพย์แห่งประเทศไทย',
      title_origin_eng: 'Source: Stock Exchange of Thailand',
      link_set_th:
        'www.set.or.th/th/market/product/stock/quote/INET/major-shareholders',
      link_set_eng:
        'www.set.or.th/en/market/product/stock/quote/INET/major-shareholders'
    },
    // ShareholderMeeting
    shareholder_meeting_page: {
      title_year_th: 'ปี',
      title_year_eng: 'Year',
      title_section1_th: 'การประชุมผู้ถือหุ้น',
      title_section1_eng: 'Shareholder’s Meeting',
      title_section2_th: 'เอกสารการประชุม',
      title_section2_eng: 'Documents of Meeting',
      img_dot: 'assets/images/56-1/dot.png',
      img_documents_now:
        'assets/images/ShareholderMeeting/bgDocumentMeetingNow.png',
      img_now: 'assets/images/ShareholderMeeting/bgMeetingNow.png',
      title_now_th: 'การประชุมผู้ถือหุ้น ประจำปี',
      title_now_eng: 'Shareholder’s Meeting'
    },
    // CompanyVisit
    company_visit: {
      title_th: 'Company Visit',
      title_eng: 'Company Visit',
      image_title: 'assets/images/news/news_icon.png'
    },
    // presentationWebcast
    presentation_webcast: {
      title_th: 'Presentation & Webcast',
      title_eng: 'Presentation & Webcast',
      image_title: 'assets/images/news/news_icon.png',
      img_dot: 'assets/images/presentationWebcast/dot.png',
      img_banner_th:
        'assets/images/presentationWebcast/bannerPresentationWebcast_th.png',
      img_banner_eng:
        'assets/images/presentationWebcast/bannerPresentationWebcast_eng.png',
      title_select_th: 'เลือกปีที่ต้องการ',
      title_select_eng: 'Select year'
    },
    file_presentation_webcast: [
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 1/2567',
        title_eng: 'English file ไตรมาส 1/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      },
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 2/2567',
        title_eng: 'English file ไตรมาส 2/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      },
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 3/2567',
        title_eng: 'English file ไตรมาส 3/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      },
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 4/2567',
        title_eng: 'English file ไตรมาส 4/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      },
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 5/2567',
        title_eng: 'English file ไตรมาส 5/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      },
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 6/2567',
        title_eng: 'English file ไตรมาส 6/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      },
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 7/2567',
        title_eng: 'English file ไตรมาส 7/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      },
      {
        title_th: 'บริษัทจดทะเบียนพบผู้ลงทุน ไตรมาส 8/2567',
        title_eng: 'English file ไตรมาส 8/2567',
        date: '15/04/2567',
        link_th: 'https://youtu.be/9WQF_cAZrr4?si=_7-CY10NeEJ7NtyY',
        link_eng: 'https://youtu.be/6Ca4t6tiB6U?si=_N8BIxe5_B5mHM9Z',
        file_download_th:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf',
        file_download_eng:
          'https://ir.inet.co.th/api/v1/file/0911c731-587a-45b4-8434-9aded5f84f56.pdf'
      }
    ],
    // debentureInformation
    debenture_information_page: {
      title_th: 'ข้อมูลหุ้นกู้',
      title_eng: 'Debenture Information',
      img_dot: 'assets/images/56-1/dot.png'
    },
    // esgStructuredDataReport
    esg_structured_data_report_page: {
      title_esg_structured_data_report_th: 'ESG Structured Data Report',
      title_esg_structured_data_report_eng: 'ESG Structured Data Report',
      img_dot: 'assets/images/esgStructuredDataReport/dot.png',
      btn_view_all_th: 'ดูทั้งหมด',
      btn_view_all_eng: 'View All',
      title_download_th: 'ดาวน์โหลด',
      title_download_eng: 'Download'
    },
    esg_structured_data_report: []
  },
  getters: {
    userInfo: (state) => {
      return state.userInfo
    },
    announceData: (state) => {
      return state.announce
    },
    valScroll: (state) => {
      return state.offsetTop
    },
    stock: (state) => {
      return state.stock
    },
    language: (state) => {
      return state.language
    },
    itemIrNews: (state) => {
      return state.IR_news
    },
    itemNews: (state) => {
      return state.news
    },
    itemNewsESG: (state) => {
      return state.news_esg
    },
    item_inet_vision: (state) => {
      return state.inet_vision
    },
    item_inet_mission: (state) => {
      return state.inet_mission
    },
    item_inet_core_value: (state) => {
      return state.inet_core_value
    },
    itemFoot: (state) => {
      return state.footer
    },
    item_annual_report_section: (state) => {
      return state.annual_report_section
    },
    item_annual_report: (state) => {
      return state.annual_report
    },
    item_annual_report_now: (state) => {
      return state.annual_report_now
    },
    item_report561_section: (state) => {
      return state.report561_section
    },
    // financialInformationMain > annualReport
    item_annual_report_page: (state) => {
      return state.annual_report_page
    },
    // financialInformationMain > 56-1
    item_report561_page: (state) => {
      return state.report561_page
    },
    item_report561: (state) => {
      return state.report561
    },
    // shareholderInformation > stockInformation
    item_stock_information_page: (state) => {
      return state.stock_information_page
    },
    // contactPage
    item_contact_page: (state) => {
      return state.contact_page
    },
    // inetW2 ใบสำคัญแสดงสิทธิ
    item_inet_w2_page: (state) => {
      return state.inet_w2_page
    },
    // Debentures of Inet หุ้นกู้ INET
    item_debentures_of_inet_page: (state) => {
      return state.debentures_of_inet_page
    },
    // corporateGovernance
    item_corporate_governance_page: (state) => {
      return state.corporate_governance_page
    }, // cac page
    item_cac_page: (state) => {
      return state.cac_page
    },
    item_complaint_channels: (state) => {
      return state.complaint_channels
    },
    // managementTeam
    item_management_team_page: (state) => {
      return state.management_team_page
    },
    // esgPage
    item_esg_page: (state) => {
      return state.esg_page
    },
    item_economy: (state) => {
      return state.economy
    },
    // financialInformationPage
    item_financial_page: (state) => {
      return state.financial_page
    },
    item_environment: (state) => {
      return state.environment
    },
    item_society: (state) => {
      return state.society
    },
    item_md_and_a_page: (state) => {
      return state.md_and_a_page
    },
    item_dividend_policy_page: (state) => {
      return state.dividend_policy_page
    },
    item_shareholding_structure_page: (state) => {
      return state.shareholding_structure_page
    },
    item_shareholder_meeting_page: (state) => {
      return state.shareholder_meeting_page
    },
    item_company_visit: (state) => {
      return state.company_visit
    },
    item_presentation_webcast: (state) => {
      return state.presentation_webcast
    },
    item_file_presentation_webcast: (state) => {
      return state.file_presentation_webcast
    },
    item_debenture_information_page: (state) => {
      return state.debenture_information_page
    },
    item_esg_structured_data_report_page: (state) => {
      return state.esg_structured_data_report_page
    },
    item_esg_structured_data_report: (state) => {
      return state.esg_structured_data_report
    }
  },
  mutations: {
    setLanguage (state, newData) {
      VueCookies.set('language', newData, '1h')
      state.language = newData
    },
    offsetTop (state, newData) {
      state.offsetTop = newData
    },
    setUserInfo (state, newData) {
      state.userInfo = newData
    }
  },
  actions: {},
  modules: {}
})
